export default "__VITE_ASSET__4b13b016__"